import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "category__product-card" };
const _hoisted_2 = {
    key: 0,
    class: "product-flags__container product-flags__right"
};
const _hoisted_3 = { class: "product-image" };
const _hoisted_4 = { class: "image__container" };
const _hoisted_5 = ["data-url", "alt"];
const _hoisted_6 = { class: "flex-grow-1 d-flex flex-column p-2" };
const _hoisted_7 = { class: "small mb-1" };
const _hoisted_8 = { class: "title" };
const _hoisted_9 = { class: "text-end" };
const _hoisted_10 = { class: "font-weight-bolder text-primary m-0" };
const _hoisted_11 = { class: "small" };
const _hoisted_12 = {
    key: 1,
    class: "align-self-end row small mt-2 gx-0 w-100"
};
const _hoisted_13 = { class: "col-5 pe-1" };
const _hoisted_14 = { class: "col-7 ps-1" };
const _hoisted_15 = {
    key: 2,
    class: "align-self-end small mt-2 gx-2 w-100"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_link = _resolveComponent("router-link");
    const _component_g_quantity_field = _resolveComponent("g-quantity-field");
    const _component_g_button = _resolveComponent("g-button");
    const _component_g_field_container = _resolveComponent("g-field-container");
    const _directive_lazy_load = _resolveDirective("lazy-load");
    return (_openBlock(), _createElementBlock("section", _hoisted_1, [
        (_ctx.product.flags && _ctx.product.flags.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.product.flags, (flag) => {
                    return (_openBlock(), _createElementBlock("div", {
                        class: _normalizeClass(['flag', flag.cssClass]),
                        style: _normalizeStyle({ color: flag.foreColor, 'background-color': flag.backgroundColor })
                    }, _toDisplayString(flag.caption), 7));
                }), 256))
            ]))
            : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
                _withDirectives((_openBlock(), _createBlock(_component_router_link, {
                    to: _ctx.product.url,
                    class: "image__lazy"
                }, {
                    default: _withCtx(() => [
                        (_ctx.product.images && _ctx.product.images.length > 0 && _ctx.product.images[0].fullUrl)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                "data-url": _ctx.product.images[0].fullUrl,
                                alt: _ctx.product.title,
                                class: "image-item"
                            }, null, 8, _hoisted_5))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }, 8, ["to"])), [
                    [_directive_lazy_load]
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_router_link, {
                to: _ctx.product.url,
                title: _ctx.product.title,
                class: "link-unstyled flex-grow-1"
            }, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.product.itemNumber), 1),
                    _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.product.title), 1)
                ]),
                _: 1
            }, 8, ["to", "title"]),
            (_ctx.product.showPrices)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: _ctx.product.url,
                    title: _ctx.product.title,
                    class: "align-self-end mt-2 link-unstyled"
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("h5", _hoisted_10, _toDisplayString(_ctx.product.priceFormatted), 1),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.product?.priceNotes, (note) => {
                                return (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(note.text), 1));
                            }), 256))
                        ])
                    ]),
                    _: 1
                }, 8, ["to", "title"]))
                : _createCommentVNode("", true),
            (_ctx.product.allowOrder && _ctx.product.canOrder && _ctx.$host.options.get('ecommerce_' + _ctx.mode + '_ordermode', _ctx.product?.options, _ctx.options) === 'quick')
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                        _createVNode(_component_g_quantity_field, {
                            "input-attr": { class: 'text-center' },
                            "data-object": _ctx.$data,
                            quantity: _ctx.product?.quantityData,
                            showLabel: false,
                            "data-member": "cart.quantity",
                            "data-mode": "model"
                        }, null, 8, ["data-object", "quantity"])
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                        _createVNode(_component_g_field_container, {
                            member: "toCart",
                            showLabel: false
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_g_button, {
                                    text: _ctx.$tc('client.Commerce.Products.AddToCart'),
                                    onClick: _ctx.OnToCart
                                }, null, 8, ["text", "onClick"])
                            ]),
                            _: 1
                        })
                    ])
                ]))
                : (_ctx.$host.options.get('ecommerce_' + _ctx.mode + '_detailsbutton', _ctx.product?.options, _ctx.options))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _createVNode(_component_router_link, {
                            class: "btn btn-primary w-100",
                            to: _ctx.product.url
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$tc('commerce.Product.ShowDetails')), 1)
                            ]),
                            _: 1
                        }, 8, ["to"])
                    ]))
                    : _createCommentVNode("", true)
        ])
    ]));
}
